<div class="collapsable-container">
    <div class="collapsable-container-header" (click)="collapsed = !collapsed">
        <div class="heading">
            <span class="btn-collapse"><span class="fa fa-fw fa-angle-double-down"></span></span>
            <span class="fa fa-filter"></span> Filter: {{ FilterDescription }}
        </div>
    </div>
    <div class="collapsable-container-content" [ngClass]="{'collapsed': collapsed}">
  <div class="row mt-3 ml-1">
    <div class="col-12">
        <form [formGroup]="filterFormGroup" class="">
            <div class="row">
                <div class="col-lg-3">
                    <!-- Filter -->
                    <div class="form-group row">
                        <div class="col-lg-12">
                            <yt-fw-date-picker-popup
                                formControlName="DateFrom"
                                [Label]="'FILTER.FROM-DATE'">
                            </yt-fw-date-picker-popup>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="form-group row">
                        <div class="col-lg-12">
                            <yt-fw-date-picker-popup
                                formControlName="DateTo"
                                [Label]="'FILTER.TO-DATE'">
                            </yt-fw-date-picker-popup>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group row">
                        <label class="col-form-label col-md-8 col-8"><span translate="ODABIRDOKUMENTA.POVEZANSADRUGIMA.SINGULAR"></span></label>
                        <!-- <label class="col-form-label col-2"><span translate="povezan"></span></label> -->
                        <div class="col-md-4 col-4">
                          <input
                            style="width: 20px;"
                            type="checkbox"
                            name="chkGlavni"
                            class="form-control"
                            formControlName="Povezan"
                            >
                        </div>
                    </div>
                </div>
                <div class="mr-2">
                    <button 
                        type="button" 
                        (click)="ApplyFilter()" 
                        class="btn btn-secondary"
                        ngbTooltip="{{'FILTER.APPLYFILTER.TOOLTIP' | translate }}">
                        <span class="fa fa-search"></span>
                    </button>
                </div>
                <div class="mr-2">
                  <button 
                    type="button" 
                    (click)="ResetFilter()" 
                    class="btn btn-secondary"
                    ngbTooltip="{{'FILTER.RESETFILTER.TOOLTIP' | translate }}">
                      <span class="fa fa-undo"></span>
                  </button>
              </div>
            </div>
        </form>
    </div>
  </div>
  </div>
  </div>
